var ur = window.location.href;
    setInterval(function(){ 
      if($('a.continue-shopping').length){
        
        $('a.continue-shopping').click(function(){
  $('button.drawer__close').eq(0).click()
}); 
      }

}, 1000);
if(ur.includes('/product')){
 jQuery(document).ready(function(){

 setInterval(function(){ 
$('.giraffly_price').eq(0).html($('.price__regular').eq(0).html())
$('.giraffly_price').eq(1).html($('.price__regular').eq(0).html())   
}, 100);
$('variant-selects').change(function(){
   setTimeout(function(){ 
$('.giraffly_PC_Preview_Variants_Block select').eq(0).prop('selectedIndex', $('.select select').eq(0).prop('selectedIndex'))
  $('.giraffly_PC_Preview_Variants_Block select').eq(1).prop('selectedIndex', $('.select select').eq(1).prop('selectedIndex'))
     $('.giraffly_phone_Preview_Variants_Select').eq(0).prop('selectedIndex', $('.select select').eq(0).prop('selectedIndex'))
  $('.giraffly_phone_Preview_Variants_Select').eq(1).prop('selectedIndex', $('.select select').eq(1).prop('selectedIndex'))
}, 500);
  
});    

    setInterval(function(){ 
if($('.giraffly_phoneButtonPreview:not([style*="none"])').length){
  $('body').addClass('sticky');
}
      else{
        $('body').removeClass('sticky');
      }
}, 1000);
   var gg = 0; var timergg = setInterval(function(){
  if($('.giraffly_PC_Preview_Variants_Block').length || $('.giraffly_phone_Preview_Variants_Select').length) {
setInterval(function(){ 
$('.giraffly_PCPreviewbutton.giraffly.giraffly-animated').eq(0).html($('.product-form__buttons button.product-form__submit').html());

    if($('.product-form__buttons button.product-form__submit').html().includes('Sold')){
$('.giraffly_PCPreviewbutton.giraffly.giraffly-animated').eq(0).addClass('disabled');
    }
  else{
    $('.giraffly_PCPreviewbutton.giraffly.giraffly-animated').eq(0).removeClass('disabled');
  }
}, 1000);
    $('.giraffly_PC_Preview_Variants_Block select').eq(0).change(function(){
      var dropdown = document.querySelectorAll('.select select')[0];
      var selects = document.querySelectorAll('variant-selects')[0];
      dropdown.selectedIndex = $(this).prop('selectedIndex'); 
      
      // Create and dispatch the change event
      var event = new Event('change');
      dropdown.dispatchEvent(event);
      selects.dispatchEvent(event);
    });    

    $('.giraffly_PC_Preview_Variants_Block select').eq(1).change(function(){
      var dropdown = document.querySelectorAll('.select select')[1];
      var selects = document.querySelectorAll('variant-selects')[0];
      dropdown.selectedIndex = $(this).prop('selectedIndex'); 
      
      // Create and dispatch the change event
      var event = new Event('change');
      dropdown.dispatchEvent(event);
      selects.dispatchEvent(event);
    });    
   $('.giraffly_phone_Preview_Variants_Select').eq(0).change(function(){
      var dropdown = document.querySelectorAll('.select select')[0];
      var selects = document.querySelectorAll('variant-selects')[0];
      dropdown.selectedIndex = $(this).prop('selectedIndex'); 
      
      // Create and dispatch the change event
      var event = new Event('change');
      dropdown.dispatchEvent(event);
      selects.dispatchEvent(event);
    });    
    $('.giraffly_phone_Preview_Variants_Select').eq(1).change(function(){
      var dropdown = document.querySelectorAll('.select select')[1];
      var selects = document.querySelectorAll('variant-selects')[0];
      dropdown.selectedIndex = $(this).prop('selectedIndex'); 
      
      // Create and dispatch the change event
      var event = new Event('change');
      dropdown.dispatchEvent(event);
      selects.dispatchEvent(event);
    });    

    $('.giraffly_PCPreviewbutton').eq(0).before($(`<div class="giraffly_PCPreviewbutton giraffly  giraffly-animated " style="color: #f3f4f3; background: #157d15;font-size: 16px;">
                        <span>Add to cart
</span>
                        <div class="loading-overlay__spinner hidden">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </div>`));
$('.giraffly_PCPreviewbutton').eq(1).hide()
    $('.PCPreviewbutton').eq(0).before($('.giraffly_PCPreviewbutton').eq(0).clone());
    $('.PCPreviewbutton').eq(1).hide()
    $('.giraffly_PCPreviewbutton').click(function(e){
      e.preventDefault();
      console.log('heress');
$('.product-form__buttons button.product-form__submit').eq(0).click()
    }); 

    $('.PCPreviewbutton').click(function(e){
      e.preventDefault();
      console.log('heress');
 $('.product-form__buttons button.product-form__submit').eq(0).click()
    }); 

    
    $('.giraffly_PCPreviewtitle').eq(0).after($('.loox-rating').eq(0).clone())
	$('.giraffly_PC_Preview_Variants_Block').eq(0).before($('.giraffly_PCPreviewPriceAndComparePrice'));
    $('.PCPreviewPriceAndComparePrice').eq(0).append($('.loox-rating').eq(0).clone())
   // $('span.loox-rating-label').click(function(e){
   //  e.preventDefault();
   //    $('html, body').animate({
   //      scrollTop: $('div#looxReviews').offset().top - 100
   //    }, 500);
   //  }); 
clearInterval(timergg);}if( gg > 200){clearInterval(timergg);}gg++;}, 50);
   
   
$('.product__title').eq(0).after($('div#shopify-block-loox-rating'))
$('product-form.product-form').eq(0).after($('.desc-text').eq(0));   
   var lll = 0; var timerlll = setInterval(function(){
  if($('span.loox-rating-label').length) {
	$('span.loox-rating-label').html($('span.loox-rating-label').html().replace(')', '').replace('&nbsp;', ''));

  // $('span.loox-rating-label').click(function(e){
  //   e.preventDefault();
  //   $('html, body').animate({
  //     scrollTop: $('div#looxReviews').offset().top - 100
  //   }, 500);
  // }); 
clearInterval(timerlll);}if( lll > 200){clearInterval(timerlll);}lll++;}, 50);
}); 
}